import React from "react";
import { IconButton, Grid, Typography, Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
function FileList({ attachments }) {
  // Function to handle file download
  const handleDownload = (attachment) => {
    if (attachment?.download_url) {
      // If the view_url exists, create a temporary link element to trigger the download
      const link = document.createElement("a");
      link.href = attachment.download_url;
      link.download = attachment.name; // Set the download attribute
      link.click(); // Programmatically trigger the download
    } else {
      console.error("No download URL available for this attachment.");
    }
  };

  return (
    <Grid container spacing={2}>
      {attachments?.map((attachment) => (
        <Grid item key={attachment.id} xs={12} sm={6} md={4} lg={3}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              sx={{ color: "#0FA5D9" }}
              onClick={() => handleDownload(attachment)}
              aria-label={`Download ${attachment.name}`}
            >
              <FileDownloadOutlinedIcon />
            </IconButton>
            <Tooltip title={attachment.name} arrow>
              <Typography
                variant="body1"
                style={{
                  marginRight: 10,
                  maxWidth: "150px", // You can adjust this value as needed
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <a
                  href={attachment.download_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "#434141" }}
                >
                  {attachment.name}
                </a>
              </Typography>
            </Tooltip>
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default FileList;
